// Safari and Firefox ignore sizes="auto", so the Widen Image block's "100vw" would pick a file
// for the whole screen. Replacing it with the measured width lets every browser choose the right
// file. Until an image loads, sizes follows its width both ways, as nothing has been fetched yet.
// Once loaded, only growth is applied: browsers never fetch a smaller file, so shrinking is wasted.
const widenImageSizes = () => {
  if (!('ResizeObserver' in window)) {
    return;
  }

  const images = document.querySelectorAll('img[data-widen-sizes]');
  if (images.length === 0) {
    return;
  }

  const sizedWidths = new WeakMap();
  const loaded = new WeakSet();
  const observer = new window.ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const image = entry.target;
      const width = Math.ceil(entry.contentRect.width);
      const previous = sizedWidths.get(image) || 0;
      const grewOrUnloaded = width > previous || (!loaded.has(image) && width !== previous);
      if (width > 0 && grewOrUnloaded) {
        sizedWidths.set(image, width);
        image.sizes = `auto, ${width}px`;
      }
    });
  });

  images.forEach((image) => {
    if (image.complete && image.naturalWidth > 0) {
      loaded.add(image);
    } else {
      image.addEventListener('load', () => loaded.add(image), { once: true });
    }
    observer.observe(image);
  });
};

export default widenImageSizes;
